module.exports = __webpack_public_path__ + "static/media/17_scratch_metal_seamless.048a8f1c.jpg";